import {
  handleError,
  setCustomAttributes,
  trackCustomEvent,
} from "@/lib/newrelic";

interface ProductSelectionParams {
  productId: string;
  price: number;
  title: string;
}

/**
 * Records New Relic monitoring for a successful product selection on the LP.
 *
 * Sets a custom attribute for the selected product id and emits a PageAction so
 * the selection can be monitored. This is New Relic monitoring only; it is
 * separate from and additive to the Tagular `elementClicked` event that fires
 * unchanged. The Tagular ProductClicked event is intentionally deferred.
 */
export const trackProductSelection = ({
  productId,
  price,
  title,
}: ProductSelectionParams): void => {
  try {
    setCustomAttributes({ selectedProductId: productId });

    trackCustomEvent("productSelected", {
      productId,
      price: String(price),
      title,
    });
  } catch (error) {
    handleError(error instanceof Error ? error : new Error(String(error)), {
      source: "trackProductSelection",
      severity: "low",
      context: { productId },
    });
  }
};
